import { useQuery } from '@tanstack/react-query';
import { ApiService } from 'api/services/ApiService';

/**
 * Hook to fetch company measurement dates
 * This provides a more direct way to get measurement dates for a company
 * compared to relying on scalar opinion data
 */
export const useCompanyMeasurementDates = (companyId: string | undefined) => useQuery({
  queryKey: ['company-measurement-dates', companyId],
  queryFn: async () => {
    if (!companyId) {
      throw new Error('Company ID is required');
    }
      
    return ApiService.apiMeasurementDatesCompanyRead(companyId);
  },
  enabled: !!companyId,
  retry: false,
  refetchOnWindowFocus: false,
  staleTime: 5 * 60 * 1000, // 5 minutes
});
